// Modified by AI on 06/09/2026. Edit #2.
import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import settings from '../../config/settings';
import { QUERY_KEYS } from '../constants/queryKeys';
import Logger from '../services/logger';
import BackendConnector from '../api/backendConnector';

const StaticDataContext = React.createContext(settings);

export const StaticDataProvider = StaticDataContext.Provider;

export const StaticDataConsumer = StaticDataContext.Consumer;

// Modified by AI on 07/01/2026. Edit #1.
export const AppWithStaticData = ({ children }) => {
    const { data: staticDataRaw, error } = useQuery({
        queryKey: QUERY_KEYS.staticData,
        queryFn: () => BackendConnector.get('metadata/staticLookups/en-US'),
        staleTime: Infinity,
        gcTime: Infinity,
        retry: false,
    });

    const staticData = staticDataRaw ?? {};

    useEffect(() => {
        if (error) {
            Logger.error(error);
        }
    }, [error]);

    return (
        <StaticDataProvider value={staticData}>
            {children}
        </StaticDataProvider>
    );
};

export default StaticDataContext;
